<template>
  <div class="supplier-page">
    <div class="page-header-bar">
      <div class="page-header-title">
        <h2>供应商管理</h2>
      </div>
      <div class="page-header-tool">
        <el-button type="primary" size="mini" @click="addNewSupplier">新增供应商</el-button>
      </div>
    </div>
    <div class="tablebox">
      <el-table :data="lists" size="small" v-loading="loading" :max-height="tablehight">
        <el-table-column label="#" prop="id" width="40"></el-table-column>
        <el-table-column label="名称" prop="supplierName" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="渠道" prop="channelname" width="60"></el-table-column>
        <el-table-column label="可用额度" prop="availableCreditStr" width="80"></el-table-column>
        <el-table-column label="单价" prop="unitPrice" width="50"></el-table-column>
        <el-table-column label="额度变动" prop="lastRechargeTime" width="120"></el-table-column>
        <el-table-column label="最近充值" prop="lastRechargeAmount" width="90"></el-table-column>
        <el-table-column label="累计充值" prop="totalRecharge"></el-table-column>
        <el-table-column label="状态" prop="statusstr" width="60">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success" size="mini">{{ scope.row.statusstr }}</el-tag>
            <el-tag v-if="scope.row.status == 0" type="info" size="mini">{{ scope.row.statusstr }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remarks" show-overflow-tooltip></el-table-column>
        <el-table-column label="QQ" prop="qq" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="微信" prop="wechat" show-overflow-tooltip></el-table-column>
        <el-table-column label="电话" prop="tel" width="100"></el-table-column>
        <el-table-column label="网址" prop="url" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="primary" :disabled="!accoutlevel" size="mini" @click="editSuppiler(scope.row)">修改</el-button>
            <el-button type="warning" :disabled="!accoutlevel" size="mini" @click="rechargeSuppiler(scope.row)">充值</el-button>
            <el-button type="success" size="mini" @click="viewDetais(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="table-pagination">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[15, 30, 50]"
        :page-size="size"
        layout="total, prev, pager, next, sizes"
        :total="totalsupplier">
      </el-pagination>      
    </div>

    <el-dialog
      :title="dialogtype == 0 ? '新增供应商' : '修改供应商'"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="addnewsupplierdialog"
      width="800px"
      center
    >
      <div class="edit-form">
        <el-form :model="supplierform" ref="addnewsupplierdialog" label-width="100px" size="mini">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="名称" prop="name">
                <el-input v-model="supplierform.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="渠道" prop="channel">  
                <el-select 
                  style="width:100%;" 
                  v-model="supplierform.channel" 
                  filterable placeholder="请选择渠道"
                >
                  <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="单价" prop="price">
                <el-input v-model="supplierform.price"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="状态" prop="status">
                <el-select 
                  style="width:100%;" 
                  v-model="supplierform.status" 
                  filterable placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in statustype"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="QQ" prop="qq">
                <el-input v-model="supplierform.qq"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="微信" prop="wechat">
                <el-input v-model="supplierform.wechat"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="电话" prop="tel">
                <el-input v-model="supplierform.tel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="网址" prop="website">
                <el-input v-model="supplierform.website"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="额度" prop="tel">
                <el-input v-model="supplierform.availableCredit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="供应商ID" prop="tel">
                <el-input v-model="supplierform.supplierNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="备注" prop="supplier_channel">
                <el-input :rows="4" type="textarea" v-model="supplierform.note"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog('supplierform')" size="small">取 消</el-button>
        <el-button type="primary" @click="dialogtype == 0 ? confirmAddSupplier() : confirmUpdateSupplier()" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="供应商充值"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="rechargedialog"
      width="400px"
      center
    >
      <div class="edit-form">
        <el-form :model="supplierform" ref="addnewsupplierdialog" label-width="100px" size="mini">
          <el-form-item label="名称">
            <el-col :span="18">
              {{ recharge_supplier.name }}
            </el-col>
          </el-form-item>
          <el-form-item label="渠道">
            <el-col :span="18">
              {{ recharge_supplier.channelname }}
            </el-col>
          </el-form-item>
          <el-form-item label="金额">
            <el-col :span="18">
              <el-input v-model="recharge_supplier.cost"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="额度">
            <el-col :span="18">
              <el-input v-model="recharge_supplier.amount"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="充值时间">
            <el-col :span="18">
              <el-date-picker
                v-model="recharge_supplier.rechargetime"
                type="datetime"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelRechargeDialog()" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmRecharge()" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

export default {
  data(){
    return{
      lists: [],
      currentPage: 1,
      page: 1,
      size: 15,
      totalsupplier: 0,
      addnewsupplierdialog: false,
      rechargedialog: false,
      supplierform: {
        id: '',
        name: '',
        channel: '',
        price: '',
        addtime: '',
        qq: '',
        wechat: '',
        tel: '',
        website: '',
        status: '',
        note: '',
        availableCredit: '',
        supplierNo: ''
      },
      channels: [{
        name: '淘宝',
        value: 1
      },{
        name: '天猫',
        value: 2
      },{
        name: '京东',
        value: 3
      },{
        name: '拼多多',
        value: 30
      },{
        name: '抖音',
        value: 45
      },{
        name: '得物',
        value: 56
      }],
      statustype: [{
        name: '正常',
        value: 1
      }, {
        name: '停用',
        value: 0
      }],
      dialogtype: 0,
      recharge_supplier: {
        id: '',
        type: '',
        name: '',
        amount: '',
        cost: '',
        rechargetime: ''
      },
      loading: true,
      accoutlevel: window.btoa(this.getLocalStorage('account')) === 'ZGF2aWQubGl1QHNpbXBseWJyYW5kLmNvbQ==',
      tablehight: window.innerHeight - 160
    }
  },

  mounted(){
    this.getSupplierList()
  },

  methods: {

    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.page = 1
      that.size = val
      that.getSupplierList()
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.page = val
      that.getSupplierList()
    },

    /**
     * 供应商列表
     */
    getSupplierList: function(){
      let that = this
      let url = that.API_URL + '/sys/suppliers/list?supplierId=0&page=' + that.page + '&size=' + that.size
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          let _lists = data.results[0]
          _lists.forEach(item => {
            item.channelname = that.formatChannelStr(item.channelId)
            item.statusstr = that.formatStatusStr(item.status)
            item.lastRechargeTime = that.$moment(item.lastRechargeTime).local().format('YYYY-MM-DD HH:mm')
            item.availableCreditStr = that.millonFormat(item.availableCredit)
          })
          that.totalsupplier = data.results[1][0].Count
          that.lists = _lists
          that.loading = false
        },
        error: function(response) {
          console.log('getSupplierList', response)
        }
      })
    },

    cancelDialog: function(){
      this.addnewsupplierdialog = false
      this.supplierform = {
        id: '',
        name: '',
        channel: '',
        price: '',
        addtime: '',
        qq: '',
        wechat: '',
        tel: '',
        website: '',
        status: '',
        note: '',
        availableCredit: '',
        supplierNo: ''
      }
    },

    addNewSupplier: function(){
      this.addnewsupplierdialog = true
      this.dialogtype = 0 // 0新增；1修改
    },

    /**
     * 新增供应商
     */
    confirmAddSupplier: function(){
      let that = this
      let api_url = that.API_URL + '/sys/suppliers/add'
      let query_data = {
        supplierName: this.supplierform.name,
        channelId: this.supplierform.channel,
        unitPrice: this.supplierform.price,
        remarks: this.supplierform.note,
        qq: this.supplierform.qq,
        wechat: this.supplierform.wechat,
        tel: this.supplierform.tel,
        url: this.supplierform.website,
        status: this.supplierform.status,
        supplierNo: this.supplierform.supplierNo
      }
      $.ajax({
        url: api_url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query_data,
        success: function(data) {
          console.log('confirmAddSupplier', data)
          that.cancelDialog()
          that.$message({
            message: '供应商添加成功',
            type: 'success'
          });
          that.dialogtype = 0
          that.getSupplierList()
        },
        error: function(response) {
          console.log('confirmAddSupplier', response)
        }
      })
    },

    editSuppiler: function(row){
      this.addnewsupplierdialog = true
      this.dialogtype = 1 // 0新增；1修改
      this.supplierform={
        id: row.id,
        name: row.supplierName,
        channel: row.channelId,
        price: row.unitPrice,
        addtime: '',
        qq: row.qq,
        wechat: row.wechat,
        tel: row.tel,
        website: row.url,
        status: row.status,
        note: row.remarks,
        availableCredit: row.availableCredit,
        supplierNo: row.supplierNo
      }
    },

    confirmUpdateSupplier: function(){
      let that = this
      let api_url = that.API_URL + '/sys/suppliers/update'
      let query_data = {
        id: this.supplierform.id,
        supplierName: this.supplierform.name,
        channelId: this.supplierform.channel,
        unitPrice: this.supplierform.price,
        remarks: this.supplierform.note,
        qq: this.supplierform.qq,
        wechat: this.supplierform.wechat,
        tel: this.supplierform.tel,
        url: this.supplierform.website,
        status: this.supplierform.status,
        availableCredit: this.supplierform.availableCredit,
        supplierNo: this.supplierform.supplierNo
      }
      $.ajax({
        url: api_url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query_data,
        success: function(data) {
          console.log('editSuppiler', data)
          that.cancelDialog()
          that.$message({
            message: '供应商修改成功',
            type: 'success'
          });
          that.dialogtype = 0
          that.getSupplierList()
        },
        error: function(response) {
          console.log('editSuppiler', response)
        }
      })
    },

    /**
     * 充值
     */
    rechargeSuppiler: function(row){
      this.rechargedialog = true
      this.recharge_supplier.id = row.id
      this.recharge_supplier.name = row.supplierName
      this.recharge_supplier.channelname = row.channelname
    },

    cancelRechargeDialog: function(){
      this.rechargedialog = false
      this.recharge_supplier = {
        id: '',
        type: '',
        name: '',
        cost: '',
        amount: '',
        rechargetime: ''
      }
    },

    confirmRecharge: function(){
      let that = this
      let api_url = that.API_URL + '/sys/suppliers/addDetail'
      let query_data = {
        supplierId: this.recharge_supplier.id,
        type: 1,
        availableCredit: this.recharge_supplier.amount,
        unitPrice: this.recharge_supplier.cost,
        createtime: that.$moment(that.recharge_supplier.rechargetime).format('YYYY-MM-DD HH:mm')
      }
      $.ajax({
        url: api_url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query_data,
        success: function(data) {
          console.log('editSuppiler', data)
          that.cancelDialog()
          that.$message({
            message: '充值成功',
            type: 'success'
          });
          that.rechargedialog = false
          that.getSupplierList()
          this.recharge_supplier = {
            id: '',
            type: '',
            name: '',
            cost: '',
            amount: '',
            rechargetime: ''
          }
        },
        error: function(response) {
          console.log('editSuppiler', response)
        }
      })
    },

    /**
     * 查看明细
     */
    viewDetais: function(id){
      this.$router.push({name: 'SupplierDetail',params: {Id: id}})
    },

    formatChannelStr: function(id){
      let src = ''
      id = id * 1
      switch (id) {
        case 1:
          src = "淘宝";
          break;
        case 2:
          src = '天猫';
          break;
        case 3:
          src = "京东";
          break;
        case 30:
          src = '拼多多';
          break;
        case 45:
          src = '抖音';
          break;
        case 56:
          src = '得物';
          break;
      }
      return src
    },

    formatStatusStr: function(id){
      let src = ''
      id = id * 1
      switch (id) {
        case 0:
          src = "停用";
          break;
        case 1:
          src = '正常';
          break;
      }
      return src
    }

  }
}
</script>